/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("FrontCallService", ["InitService"], function (context, cls) {
  /**
   * @namespace gbc.FrontCallService
   * @gbcService
   */
  class FrontCallService /** @lends gbc.FrontCallService */ {
    constructor() {
      /**
       * list of available front call modules
       * @type {Object}
       * */
      this.modules = {};
      /**
       * currently running front call
       * @type {classes.NodeBase}
       * */
      this._functionCallNode = null;

      /** @type {boolean} */
      this._functionCallProcessing = false;

      /** @type {boolean} */
      this._useBrowserFrontCalls = true;

      /** @type {Object<string, string|Array<string>>} */
      this._forcedURFrontCalls = null;
    }

    /**
     * Initialize the service
     */
    init() {
      const lowerCasedModules = {};
      const moduleNames = Object.keys(this.modules);
      for (const moduleName of moduleNames) {
        const module = this.modules[moduleName];
        const functionNames = Object.keys(module);
        const lowerCasedModule = {};
        lowerCasedModules[moduleName.toLowerCase()] = lowerCasedModule;
        for (const functionName of functionNames) {
          lowerCasedModule[functionName.toLowerCase()] = module[functionName];
        }
      }
      this.modules = lowerCasedModules;
    }

    /**
     * Check if the module exist
     * @param {string} module - name of the frontcall module (i.e: standard, mobile ...)
     * @return {boolean}
     */
    hasModule(module) {
      return Boolean(this.modules[module.toLowerCase()]);
    }

    /**
     * Check if module has a frontcall
     * @param {string} module - name of the frontcall module (i.e: standard, mobile ...)
     * @param {string} name - name of the function (i.e: feinfo, openDir, playSound...)
     * @return {boolean} - true if frontcall exist in the module
     */
    hasFrontCall(module, name) {
      const moduleItem = this.modules[module.toLowerCase()];
      if (moduleItem) {
        return Boolean(moduleItem[name.toLowerCase()]);
      } else {
        return false;
      }
    }

    /**
     * Check if a functionCall is processing
     * @return {boolean} true if processing, false otherwise
     */
    functionCallIsProcessing() {
      return this._functionCallProcessing;
    }

    /**
     * Tell the service that a FrontCall is processing or not
     * @param {boolean} processing - true if processing
     */
    setFunctionCallProcessing(processing) {
      this._functionCallProcessing = processing;
    }

    /**
     * Set if we must use browser or native frontcalls
     * @param {boolean} useBrowserFrontCalls
     */
    setUseBrowserFrontCalls(useBrowserFrontCalls) {
      this._useBrowserFrontCalls = useBrowserFrontCalls;
    }

    /**
     * Get if we must use browser or native frontcalls
     * @return {boolean}
     */
    useBrowserFrontCalls() {
      return this._useBrowserFrontCalls;
    }

    /**
     * Set list of frontcalls per module forced to be called at browser side
     * @param {Object<string, string|Array<string>>} forcedURFrontCalls
     */
    setForcedURFrontCalls(forcedURFrontCalls) {
      this._forcedURFrontCalls = forcedURFrontCalls;
    }

    /**
     * in native mode, will check if function call is forced to be done by UR
     * @param {string} moduleName the function call module
     * @param {string} functionName the function call name
     * @return {boolean} whether or not function call is forced to by done by UR
     */
    isFrontCallURForced(moduleName, functionName) {
      if (!this._forcedURFrontCalls) {
        return false;
      }
      return (
        Boolean(this._forcedURFrontCalls[moduleName]) &&
        (this._forcedURFrontCalls[moduleName] === "*" || this._forcedURFrontCalls[moduleName].indexOf(functionName) >= 0)
      );
    }
  }

  gbc.FrontCallService = new FrontCallService();
  context.InitService.register(context.FrontCallService);
});
